import {
  CustomFeaturedContent,
  FeaturedTag,
  Recipe,
} from '../../types/fam-graphql'
import { RecipesHighlightSectionProps } from '../../components/RecipesHighlightSection'
import { recipeCardTransformer } from '../Recipe/RecipeCard'
import { crossLinkCardTransformer } from '../Crosslink'
import { featuredTagCardTransformer } from '../Tag'

export const recipesHighlightTransformer = (
  featured: any,
  isMobile?: boolean,
  t?: any
): RecipesHighlightSectionProps => ({
  carouselName: t('recipes_highlight_carousel_name'),
  title: featured?.title ?? '',
  maxChars: isMobile ? 100 : 200,
  description: featured?.description ?? '',
  cards: featured?.content?.map(
    (c: Recipe | CustomFeaturedContent | FeaturedTag) => {
      if (c?.__typename === 'Recipe') {
        return {
          ...recipeCardTransformer(t, c),
          forceLandscape: true,
        }
      } else if (c?.__typename === 'CustomFeaturedContent') {
        return {
          ...crossLinkCardTransformer(c, t),
          forceLandscape: true,
        }
      } else if (c?.__typename === 'FeaturedTag') {
        return {
          ...featuredTagCardTransformer(c, t),
          forceLandscape: true,
        }
      }
    }
  ),
  seeMoreText: t('recipes_highlight_seemore'),
  seeLessText: t('recipes_highlight_seeless'),
})
